export function bankNumberIsInter(numberBank: string) {
    return numberBank === '077';
}